module.exports = __webpack_public_path__ + "assets/img/th-91e1367a.png";